import { PermissionModel } from '../permissions';

export class DataViewsPermissionsForEndUserPresenterModel {
  isAuthenticated: boolean;
  isRestricted: boolean;
  permissions?: Array<PermissionModel>;
}
